import { reactive, ref } from 'vue';
import * as echarts from "echarts";
import './china';
import {getCityGroupDimension, getEffectiveRent} from "@/service/api";
import request from "@/service/request";

const point = require('@/assets/images/point.png');
export const cityColors = [
    ["rgba(152, 60, 248, 1)", "rgba(152, 60, 248, 0.1)"],
    ["rgba(81, 65, 244, 1)", "rgba(81, 65, 244, 0.1)"],
    ["rgba(48, 128, 232, 1)", "rgba(48, 128, 232, 0.1)"],
    ["rgba(49, 201, 232, 1)", "rgba(49, 201, 232, 0.1)"],
    ["rgba(45, 232, 189, 1)", "rgba(45, 232, 189, 0.1)"],
    ["rgba(49, 231, 73, 1)", "rgba(49, 231, 73, 0.1)"],
    ["rgba(164, 232, 47, 1)", "rgba(164, 232, 47, 0.1)"],
    ["rgba(232, 226, 47, 1)", "rgba(232, 226, 47, 0.1)"],
    ["rgba(231, 183, 47, 1)", "rgba(231, 183, 47, 0.1)"],
    ["rgba(232, 140, 48, 1)", "rgba(232, 140, 48, 0.1)"],
    ["rgba(198, 125, 84, 1)", "rgba(198, 125, 84, 0.1)"],
    ["rgba(38, 158, 161, 1)", "rgba(38, 158, 161, 0.1)"],
    ["rgba(34, 72, 199, 1)", "rgba(34, 72, 199, 0.1)"],
    ["rgba(255, 164, 164, 1)", "rgba(255, 164, 164, 0.1)"]
];


export let citys = ref([]);
function fillColors(list) {
    return list.map((city, index) => ({
        name: city.groupname,
        color: cityColors[index],
        value:(city.citygroupAreaTotalRate*100).toFixed(2)
    }))
}

export function setCitys(list) {
    citys.value = fillColors(list);
}

export const expectIncrementDOM = ref(null);
let expectIncrementChartInstance;

export function expectIncrementChart(info) { //现有存量与未来三年预计增量
    expectIncrementChartInstance = echarts.init(expectIncrementDOM.value);
    let option = {
        tooltip: {
            show:false

        },
        grid: {
            top: 50,
            bottom: 30,
            left: 100,
            right: 0
        },
        xAxis: {
            type: 'category',
            data: info.map(item=>item.groupname),
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                color: '#999',
                interval: 0
            }
        },
        yAxis: {
            name: "万/㎡",
            type: 'value',
            splitLine: {
                show: false
            },
            nameTextStyle: {
                align: 'left'
            },
            axisLabel: {
                color: '#666'
            }
        },
        series: [
            {
                data: info.map(item=>item.areatotal/10000),
                type: 'bar',
                stack: 'one',
                barWidth: 20,
                itemStyle: {
                    color: "#31C9E8",
                    borderRadius: [0, 0, 10, 10]
                }
            },
            {
                data: info.map(item=>(item.nextthreeyearsincrement/10000)),
                type: 'bar',
                barWidth: 20,
                stack: 'one',
                itemStyle: {
                    color: "#CFE6EB",
                    borderRadius: [10, 10, 0, 0]
                }
            }
        ]
    }
    expectIncrementChartInstance.setOption(option);
}

export const totalChartDOM = ref(null);
let totalChartInstance;
export function totalChart(arr) { //长三角城市群高标仓总体量
    totalChartInstance = echarts.init(totalChartDOM.value);
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                lineStyle: {
                    color: '#0A9BFC'
                }
            },
            formatter(a) {
                let year = a[0].axisValue;
                let html = '';
                a.forEach((item, index) => {
                    let x = '';
                    let val = item.value?index===2?(item.value).toFixed(2)+'%':item.value.toFixed(2):''
                    if (index == 0) {
                        x = `<div class='g-chart-icon g-chart-icon-block' style='background:#0A9BFC'></div>`
                    } else if (index == 1) {
                        x = `<div class='g-chart-icon g-chart-icon-block' style='background:#C2DBEC'></div>`
                    } else if (index == 2) {
                        x = `
                            
                            <div class='g-chart-icon g-chart-icon-line' style='background:#C2DBEC'>
                                <span style='background:#0A9BFC;'></span>    
                                <div class='g-chart-icon-circle' style='border-color:#0A9BFC'></div>
                            </div>
                        `
                    }
                    html += `
                    <div class='g-chart-item'>
                        ${x}
                        <span>${item.seriesName}：${val}</span>
                    </div>
                    `
                })

                return `
                    <div>
                        <p class='g-chart-title'>${year}</p>
                        <div class='g-chart-list'>
                            ${html}
                        </div>
                    </div>
                `
            }
        },
        grid: {
            top: 30,
            bottom: 30,
            left: 30,
            right: 50
        },
        xAxis: [
            {
                type: 'category',
                data: arr.map(item=>item.year),
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: '#999'
                }
            }
        ],
        yAxis: [
            {
                name: "万/㎡",
                type: 'value',
                splitLine: {
                    show: false
                },
                nameTextStyle: {
                    align: 'left'
                },
                axisLabel: {
                    color: '#666',

                }
            },
            {
                name: "占比全国高标仓比例",
                type: 'value',
                axisLabel: {
                    formatter: '{value}%'
                },
                splitLine: {
                    show: false
                },
                nameTextStyle: {
                    align: 'right',
                    width: 3000
                },

            }
        ],
        series: [
            {
                name: "高标仓总体量",
                data:arr.map(item=>item.areaTotal/10000),
                type: 'bar',
                stack: 'one',
                barWidth: 20,
                itemStyle: {
                    color: "#0A9BFC",
                    borderRadius: [0, 0, 10, 10]
                }
            },
            {
                name: "预计增量",
                data:arr.map(item=>item.preAdd/10000),
                type: 'bar',
                barWidth: 20,
                stack: 'one',
                itemStyle: {
                    color: "#CFE6EB",
                    borderRadius: [10, 10, 0, 0]
                }
            },
            {
                name: "占比全国高标仓比例",
                data: arr.map(item=>item.nationwideAreaTotalRate*100),
                type: 'line',
                yAxisIndex: 1,
                symbolSize: 8,
                lineStyle: {
                    color: "#0A9BFC",
                },
                itemStyle: {
                    color: "#0A9BFC",
                },
                areaStyle: {
                    opacity: 0.8,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(75, 173, 255, 0.8)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(255, 255, 255, 0)'
                        }
                    ])
                },
            }
        ]
    }
    totalChartInstance.setOption(option);
}


export let citysTableData = ref([]);



function resizeCurrentPage() {
    expectIncrementChartInstance.resize();
    totalChartInstance.resize();
    chinaChart.resize();
    chinaChartOutLine.resize();
}


export let chinaChartDOM = ref(null);
export let chinaChartBottomDOM = ref(null);

let chinaChart;
let chinaChartOutLine;

export function chinaMap(list) {
    console.log(list)
    chinaChart = echarts.init(chinaChartDOM.value);
    chinaChartOutLine = echarts.init(chinaChartBottomDOM.value);
    let option = {
        geo: {
            map: "china", // 表示中国地图
            roam: false,
            scale: false,
            silent: true,
            zoom: 1.1,
            itemStyle: {
                areaColor: "#e9f5ff",
                borderColor: "#abd9ff",
                borderWidth: 2
            },
            projection: {
                project: (point) => [point[0] / 180 * Math.PI, -Math.log(Math.tan((Math.PI / 2 + point[1] / 180 * Math.PI) / 2))],
                unproject: (point) => [point[0] * 180 / Math.PI, 2 * 180 / Math.PI * Math.atan(Math.exp(point[1])) - 90]
            },
            regions: list.map(item=>({
                name: item.name,
                itemStyle: {
                    areaColor: "#4BADFF",
                    borderColor: "#75f3ff",
                    borderWidth: 1,
                    shadowOffsetX: -2,
                    shadowOffsetY: -2,
                    shadowColor: '#1567AB',
                    shadowBlur: 1
                }
            })),
            emphasis: {
                disabled: true
            }
        },
        tooltip: {
            formatter(val) {
                return `
                    <div class='map-tip-format'>
                        <p>${val.name}</p>
                        <div>现有存量：${val.value[2]}㎡</div>
                        <div>未来三年预计增量：${val.value[3]}㎡</div>
                    </div>
                `
            },
        },
        series: [
            {
                type: "map",
                name: "inner",
                geoIndex: 0,

            },
            {
                type: "scatter",
                coordinateSystem: "geo",
                animation: false,
                data:list.map(item=>({
                    name: item.name,
                    cityCode: item.code,
                    value: [item.gpsLon, item.gpsLat, 123, 22]
                })),
                // emphasis: {
                //     label: {
                //         show: true,
                //         color: "#fff",
                //         fontSize: 14
                //     }
                // },
                label: {
                    show: true,
                    position: "top",
                    backgroundColor: "transparent",
                    color: "#0262B2",
                    formatter(params) {
                        return params.name;
                    },
                },
                itemStyle: {
                    color: "#fff"
                },
                symbol(val) {
                    return 'image://' + point;
                },
                // symbolSize(val) {
                //     return val[val.length - 4] ? [46, 46] : [11, 11]
                // }
            }
        ]
    };



    let chinaMapOutLineOption = {
        geo: {
            map: "china", // 表示中国地图
            silent: true,
            zoom: 1.1,
            projection: {
                project: (point) => [point[0] / 180 * Math.PI, -Math.log(Math.tan((Math.PI / 2 + point[1] / 180 * Math.PI) / 2))],
                unproject: (point) => [point[0] * 180 / Math.PI, 2 * 180 / Math.PI * Math.atan(Math.exp(point[1])) - 90]
            },
            label: {
                show: false
            },
            itemStyle: {
                areaColor: "rgba(131,199,255,1)",
                borderColor: "rgba(131,199,255,1)",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowColor: '#1567AB',
                shadowBlur: 10
            }
        }
    }
    chinaChart.setOption(option)
    chinaChartOutLine.setOption(chinaMapOutLineOption, true);
}

export const init = () => {
    window.addEventListener('resize', resizeCurrentPage);
}

export const destory = () => {
    window.removeEventListener('resize', resizeCurrentPage);
}